package com.wintermar.inspection.feature.presentation.inspection.complete_answer

import androidx.lifecycle.ViewModel
import com.wintermar.inspection.feature.domain.model.answer.CompleteAnswerModel

class CompleteAnswerViewModel(
    summaryData: CompleteAnswerModel,
) : ViewModel() {
    val state = CompleteAnswerState()

    init {
        state.data = summaryData
    }
}
